export default __webpack_public_path__ + "static/Plots0003-2dc320d589113ad2d5a612adb9cc18cd.jpg";